var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.048 14.2559C19.0109 11.0297 21.8663 9.47225 21.9775 9.39809C20.383 7.21021 17.8613 6.91354 17.0084 6.87646C14.9318 6.65397 12.8923 8.06311 11.8169 8.06311C10.7415 8.06311 9.07274 6.91354 7.32985 6.95063C5.0678 6.98771 2.917 8.21144 1.76744 10.1397C-0.642938 14.0334 1.13703 19.7812 3.47324 22.9333C4.62281 24.4908 5.95779 26.1966 7.73776 26.1595C9.48065 26.0853 10.1111 25.1212 12.1877 25.1212C14.2643 25.1212 14.8576 26.1595 16.6747 26.1224C18.5288 26.0853 19.7155 24.5649 20.828 23.0074C22.1629 21.2275 22.6821 19.4846 22.7192 19.4104C22.645 19.3733 19.0851 18.1125 19.048 14.2559ZM15.6364 4.83691C16.5634 3.76151 17.1938 2.2782 17.0084 0.757812C15.6735 0.794895 13.9677 1.61071 13.0035 2.68611C12.1506 3.61318 11.3719 5.17066 11.5944 6.61688C13.1148 6.72813 14.6722 5.87523 15.6364 4.83691Z",
    fill: "#001ACC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple-icon.f24eeb3f1e5861a8d15de4b048ce65c2.svg";
export { ForwardRef as ReactComponent };